const BreakpointKeys = ['default', 'S', 'M', 'L', 'XL'];
const DefaultModalSize = {
  default: 200,
  S: 'min(calc(100vw - 32px), 480px)',
  M: 616,
  L: 820,
  XL: 1134,
};
const Placements = ['top', 'left', 'bottom', 'right'];
const Alignments = ['start', 'center', 'end'];
const ItemToggleTransitionMillisecond = 1500;
const FlexDirections = ['row', 'col', 'row-reverse', 'col-reverse'];
const FlexAlignItem = ['start', 'center', 'end', 'baseline', 'stretch'];
const FlexJustifyContent = [
  'start',
  'center',
  'end',
  'space-around',
  'space-between',
  'space-evenly',
];
const BoxDisplay = ['block', 'none'];

export { Alignments as A, BreakpointKeys as B, DefaultModalSize as D, FlexDirections as F, ItemToggleTransitionMillisecond as I, Placements as P, FlexAlignItem as a, FlexJustifyContent as b, BoxDisplay as c };
